// extracted by mini-css-extract-plugin
module.exports = {"simpleController":"SimpleController_simpleController__8B0U6","options":"SimpleController_options__ACAHd"};